<div mat-dialog-content>
  <h2>Opprett ny selger</h2>

  <app-ice-alert class="seller-info" type="info">
    Bruk selgerens jobb-e-post og fulle navn. Sørg for at all informasjon er korrekt.
  </app-ice-alert>

  <div class="container" [formGroup]="form">
    <mat-form-field appearance="outline" class="creditcheck-input">
      <mat-label>Fornavn</mat-label>
      <input autocomplete="off" data-testid="first-name-input" formControlName="firstName" matInput />
    </mat-form-field>

    <mat-form-field appearance="outline" class="creditcheck-input">
      <mat-label>Etternavn</mat-label>
      <input autocomplete="off" data-testid="last-name-input" formControlName="lastName" matInput />
    </mat-form-field>

    <mat-form-field appearance="outline" class="creditcheck-input">
      <mat-label>E-post</mat-label>
      <input autocomplete="off" data-testid="email-input" formControlName="email" matInput />
      @if (form.controls.email.errors) {
        <mat-error>E-post er ikke gyldig</mat-error>
      }
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions>
  <div class="buttons">
    <app-ice-button
      color="primary"
      testId="submit-create-seller-button"
      [disabled]="!(form.dirty && form.valid)"
      (click)="createSeller()"
    >
      Opprett
    </app-ice-button>
    <app-ice-button color="outlined" matDialogClose testId="cancel-create-seller-button" (click)="abort()">
      Avbryt
    </app-ice-button>
  </div>
</div>
